
const apiConfig = {
                       baseURL: "https://api.bajibet777.com",
                    //  baseURL: "http://localhost:5000",
                  };

export default apiConfig;